module.exports = __webpack_public_path__ + "img/logo-osteo-barry.ecbca5fb.png";